import React from 'react'

import { Layout, Breadcrumb } from 'antd'

const { Content } = Layout

const Dashboard = () => {

  return (
    <Layout className="site-layout">
      <Content style={{ margin: '0 16px' }}>
        <Breadcrumb style={{ margin: '16px 0' }}>
          <Breadcrumb.Item>Dashboard</Breadcrumb.Item>
        </Breadcrumb>
        <div className="bg-white" style={{ padding: 24, minHeight: "80vh" }}>
          Dashboard
        </div>
      </Content>
      {/* <Footer style={{ textAlign: 'center' }}>Ant Design ©2018 Created by Ant UED</Footer> */}
    </Layout>
  )
}


export default Dashboard